import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../models/filter.model";

@Component({
  selector: 'app-amount-range',
  templateUrl: './amount-range.component.html',
  styleUrls: ['./amount-range.component.scss']
})
export class AmountRangeComponent {
  @Input() title = ''
  @Input() filterSumFrom!: FilterModelDto
  @Input() filterSumTo!: FilterModelDto
}
